'use client'

import { PropsWithChildren } from 'react'

import { WORLD_DETAIL_SECTION_GRID } from '@/constants/content-detail-layout'
import { useBIPageView } from '@/context/BISdkContext'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { useLayoutContext } from '@/context/LayoutContext'
import { useUAContext } from '@/context/UAContext'
import { useEnableFull3d } from '@/hooks/useEnableFull3d'
import { cn } from '@/lib/utils'

function WorldPageWrapper({ children }: PropsWithChildren) {
  const { headerHeight } = useLayoutContext()
  const enableFull3d = useEnableFull3d()
  const { isMobile, isMobileApp } = useUAContext()
  const { roomData, isOwnerViversePro } = useCheckEnterRoomContext()
  const showRecommendations = !enableFull3d && !isOwnerViversePro

  useBIPageView({
    a14: roomData.vod_id ? 'Video' : 'World',
    isVoucherRoom: roomData.is_voucher_room,
  })

  return (
    <main
      className={cn('relative flex flex-1 flex-col', {
        'min-[1280px]:pl-15': !isMobileApp && !enableFull3d,
      })}
      data-section="world-detail"
      style={{
        paddingTop: enableFull3d ? 0 : headerHeight,
      }}
    >
      <section
        data-section="world-detail-layout"
        className={cn('grid grid-cols-1', {
          'gap-12 landscape:gap-0': !enableFull3d,
          'md:px-8 md:py-6 landscape:px-0 landscape:py-0': !enableFull3d,
          'px-0': enableFull3d,
          [WORLD_DETAIL_SECTION_GRID]: !enableFull3d && !isMobile && showRecommendations,
          '1.5xl:py-8 1.5xl:gap-6 lg:w-full lg:grid-cols-1 lg:gap-4 lg:px-[72px] lg:py-6':
            !enableFull3d && !isMobile && !showRecommendations,
        })}
      >
        {children}
      </section>
    </main>
  )
}

export default WorldPageWrapper
